import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { HeadingActionType, HeadingStatus } from '../../utils/constants';
export interface IHeadingActionConfig {
  label: string;
  icon?: string;
  status?: HeadingStatus;
  actionType?: HeadingActionType;
}

@Component({
  selector: 'frodo-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeadingComponent {
  @Input() actionConfig: IHeadingActionConfig;
  @Output() public actionOnClick: EventEmitter<any> = new EventEmitter();
  @Output() public backOnClick: EventEmitter<any> = new EventEmitter();
  @Output() public cancelOnClick: EventEmitter<any> = new EventEmitter();

  private buttonLabelCancel: string;

  constructor(private translateService: TranslateService) {
    this.loadTranslations();
  }

  emitActionOnClick(): void {
    this.actionOnClick.emit();
  }

  emitCancelOnClick(): void {
    this.cancelOnClick.emit();
  }

  emitBackOnClick(): void {
    this.backOnClick.emit();
  }

  isActive(): boolean {
    return this.actionConfig?.status === HeadingStatus.Active;
  }

  isActivateAction(): boolean {
    return this.isDisabled() && this.isCancelled();
  }

  isDisabled(): boolean {
    return this.actionConfig?.status === HeadingStatus.Disabled;
  }

  isDelete(): boolean {
    return this.actionConfig?.status === HeadingStatus.Delete;
  }

  isActionButton(): boolean {
    return this.actionConfig?.actionType === HeadingActionType.Button;
  }

  isActionIndicator(): boolean {
    return this.actionConfig?.actionType === HeadingActionType.Indicator;
  }

  isCancelled(): boolean {
    return this.actionConfig?.label === this.buttonLabelCancel;
  }

  loadTranslations() {
    this.translateService.get(['common.buttonLabelCancel']).subscribe((translations) => {
      this.buttonLabelCancel = translations['common.buttonLabelCancel'];
    });
  }
}
